import { Component } from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-review-submitted-dialog',
  templateUrl: './review-submitted-dialog.component.html',
  styleUrls: ['./review-submitted-dialog.component.scss']
})
export class ReviewSubmittedDialogComponent {
  done = $localize`:@@done:Done`

  constructor(
    public dialogRef: MatDialogRef<ReviewSubmittedDialogComponent>,
  ) {
  }



  closeDialog() {
    this.dialogRef.close()
  }

}
